import { FC } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { CloseModalButton } from "components/Buttons";
import BasicModal from "./BasicModal";
import {
  ModalHeading,
  ModalContent,
  MCCContent,
  MCCColumn,
  MCCLine,
} from "./styled";
import { AppText } from "components";
import { mccDataFirst, mccDataSecond } from "pages/CryptoCardsPage/dummyData";
import { colors } from "helpers/consts";

interface MCCModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const MCCModal: FC<MCCModalProps> = ({ onClose, isOpen }) => {
  const { t } = useTranslation();
  return (
    <BasicModal
      isLarge
      isOpen={isOpen}
      onClose={onClose}
      bgColor={colors.gray_25}
    >
      <ModalContent>
        <CloseModalButton onClose={onClose} label="close" />
        <ModalHeading>MCC ({t("MERCHANT_CATEGORY_CODE")})</ModalHeading>

        <MCCContent>
          <MCCColumn>
            {mccDataFirst.map(({ code, description }) => (
              <MCCLine key={code}>
                <AppText color={colors.gray_700} fontWeight={600}>
                  {code}
                </AppText>
                <AppText color={colors.gray_400} fontWeight={400}>
                  {t(description)}
                </AppText>
              </MCCLine>
            ))}
          </MCCColumn>
          <MCCColumn>
            {mccDataSecond.map(({ code, description }) => (
              <MCCLine key={code}>
                <AppText color={colors.gray_700} fontWeight={600}>
                  {code}
                </AppText>
                <AppText color={colors.gray_400} fontWeight={400}>
                  {t(description)}
                </AppText>
              </MCCLine>
            ))}
          </MCCColumn>
        </MCCContent>
      </ModalContent>
    </BasicModal>
  );
};

export default observer(MCCModal);
